import React from "react";
import { useEffect, useMemo, useState } from "react";
import { ResponseModel } from "model/utilModels/ResponseModel";
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import { PaginatorModel } from "model/utilModels/PaginatorModel";

import { msgTypes } from "constants/msgTypes";
import { Formik, Form } from "formik";
import FormikControl from "components/wrapperComponents/FormikControl";
import { ContactEnquiryService } from "services/menu/contactEnquiryService/ContactEnquiryService";

const ContactEnquiryList = () => {
  const [contactEnquiryList, setContactEnquiryList] = useState<ResponseModel | null>(null); 
  const [noRecord, setNoRecord] = useState(false);
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });

  useEffect(() => {
    getContactEnquiryList();
  }, [
    pagination.pageNumber,
    pagination.pageSize,
    pagination.filter,
    pagination.orderBy,
    pagination.desc,
  ]);

  // Prepare request body to get contact enquiry list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  };

  //Get Contact Enquiry list
  const getContactEnquiryList = async () => {
    const requestBody = prepareRequest();
    const res = await ContactEnquiryService.getContactEnquiryList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setContactEnquiryList(res);
    }
  };

  const initialValues = {};
  const onSubmit = () => {
    getContactEnquiryList();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        size: 120,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 120,
      },
      {
        accessorKey: "phone",
        header: "Phone No.",
        size: 120,
      },
      {
        accessorKey: "category",
        header: "Category",
        size: 120,
      },
      {
        accessorKey: "message",
        header: "Message",
        size: 130,
      },
    ],
    []
  );

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(formik) => (
          <Form>
              {contactEnquiryList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control="materialTable"
                  tableColumn={columns}
                  tableData={contactEnquiryList}
                  formikValue={formik}
                  setPagination={setPagination}
                />
              }
            />
          ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ContactEnquiryList;
